import { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  InputWrapper,
  ToggleButton,
  PrimaryAltButton,
  SecondaryAltButton,
  ButtonContainer
} from '../atoms';

type TFilter = {
  open: boolean;
};

const Filter = styled.form<TFilter>(
  ({ open }) => css`
    margin-top: 20px;
    max-height: 0;
    overflow: hidden;
    transition: 0.35s ease;

    ${open &&
    css`
      transition: 0.5s cubic-bezier(0.79, -0.06, 1, 1);
      max-height: 1000px;
    `}
  `
);

const InputContainer = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: end;
    grid-gap: 0 ${theme.margins.md};
    border-top: ${theme.borders.light};
    border-bottom: ${theme.borders.light};
    padding-top: ${theme.paddings.md};
    padding-bottom: ${theme.paddings.sm};

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-gap: 0 20px;

      label {
        font-size: 14px;
      }
    }
  `
);

const FormButtons = styled((props) => <ButtonContainer {...props} />)`
  margin-top: 20px;
`;

const CoursesFilter = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <div>
      <ToggleButton
        alternative={isFilterOpen}
        onClick={() => setIsFilterOpen(!isFilterOpen)}
      >
        {isFilterOpen ? 'Close' : 'Open'} Filters
      </ToggleButton>
      <Filter open={isFilterOpen}>
        <InputContainer>
          <InputWrapper
            value=""
            name="Course Name"
            type="text"
            label="Course Name"
            errorMessage={undefined}
          />
        </InputContainer>
        <FormButtons
          horizontalSpacing="6px"
          verticalSpacing="0"
          justify="flex-end"
        >
          <PrimaryAltButton type="submit">Apply Filters</PrimaryAltButton>
          <SecondaryAltButton type="reset">Reset Filters</SecondaryAltButton>
        </FormButtons>
      </Filter>
    </div>
  );
};

export { CoursesFilter };
